var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-ticket card-ticket",
    attrs: {
      isCustomizable: _vm.settings.isCustomizable,
      type: _vm.settings.context,
      error: _vm.error,
      placeholder: _vm.placeholder,
      loading: _vm.loading
    },
    on: {
      "hide-card": function($event) {
        return _vm.$emit("hide-card", "ticket")
      },
      "refresh-card": function($event) {
        return _vm.fetchCard("ticket", {}, true)
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function() {
            return [_vm._v(_vm._s(_vm.name))]
          },
          proxy: true
        },
        _vm.data && _vm.data.length > 0
          ? {
              key: "content",
              fn: function() {
                return [
                  _c("template-ticket-card", {
                    attrs: {
                      data: _vm.data,
                      name: _vm.name,
                      settings: _vm.settings,
                      type: _vm.type,
                      context: "ticket"
                    }
                  })
                ]
              },
              proxy: true
            }
          : null
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }